import { render } from "./StockInfoForm.vue?vue&type=template&id=2ed0daba&scoped=true"
import script from "./StockInfoForm.vue?vue&type=script&lang=js"
export * from "./StockInfoForm.vue?vue&type=script&lang=js"

import "./StockInfoForm.vue?vue&type=style&index=0&id=2ed0daba&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed0daba"]])

export default __exports__